<template>
  <page-edicion>
    <page-header
      :title="`Duración de contrato: ${duracionContrato.nombre}`"
      subtitle="Descuentos por duración de contrato"
      @back="volver()"
    />
    <h3>Nuevo descuento</h3>
    <b-form @submit.prevent="agregarModificador">
      <b-row class="align-items-baseline">
        <b-col>
          <b-form-group label="Tipo de cuota">
            <b-form-select v-model="nuevoMod.tipoCuota" :options="comboTiposDeCuotaDisponibles" required />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="% Descuento">
            <b-form-input
              type="number"
              v-model="nuevoMod.porcentajeModificadorPrecio"
              min="0.00"
              max="200"
              step="0.01"
              required
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-button type="submit" variant="success" size="sm">Agregar descuento</b-button>
        </b-col>
      </b-row>
    </b-form>

    <h3>Descuentos por duración de contrato y tipo de cuota: {{ duracionContrato.nombre }}</h3>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th width="40%">Tipo de cuota</th>
          <th width="40%">% Descuento</th>
          <th width="20%"></th>
        </tr>
      </thead>
      <tbody>
        <row-modificador-precio v-for="modificador in modificadores" :key="modificador.id" :modificador="modificador" />
      </tbody>
    </table>
  </page-edicion>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useModificadorPrecioModuloStore } from "@/stores/ModificadorPrecioModuloStore";
import RowModificadorPrecio from "./RowModificadorPrecio.vue";

export default {
  components: { RowModificadorPrecio },
  computed: {
    ...mapState(useModificadorPrecioModuloStore, ["duracionContrato", "modificadores", "comboTiposDeCuota"]),
    comboTiposDeCuotaDisponibles() {
      return this.comboTiposDeCuota.map((tipo) => {
        return {
          value: tipo.value,
          text: tipo.text,
          disabled: this.modificadores.find((mod) => mod.tipoCuota === tipo.value),
        };
      });
    },
  },
  data() {
    return {
      nuevoMod: {},
    };
  },
  methods: {
    ...mapActions(useModificadorPrecioModuloStore, ["guardarModificador"]),
    async agregarModificador() {
      await this.guardarModificador(this.nuevoMod);
      this.nuevoMod = {};
    },
    volver() {
      if (this.$route.query.from == "editar") {
        console.log("Volver a editar");
        this.$router.push("/duracionesContrato/editar/" + this.duracionContrato.id);
      } else {
        console.log("Volver a listar");
        this.$router.push("/duracionesContrato");
      }
    },
  },
  watch: {
    "$route.params": {
      handler: function () {
        const store = useModificadorPrecioModuloStore();
        const id = this.$route.params.id;
        store.cargar(id);
        store.cargarModificadores(id);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
